import React from 'react'

import { List, Overlay } from './styles'

const Component = ({ children, disabled, ...rest }) => (
  <List {...rest}>
    {children}
    {disabled && <Overlay active={disabled} />}
  </List>
)

Component.displayName = 'List'

export default Component
